'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createAppKit } from '@reown/appkit/react'
import { WagmiProvider } from 'wagmi'
import { wagmiAdapter } from './wagmi'


export const bsc = {
  id: 56,
  name: 'Binanace',
  network: 'bsc',
  rpcUrls: {
    default: 'https://bsc-dataseed1.bnbchain.org',
    public: 'https://bsc-dataseed1.bnbchain.org',
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://bscscan.com/' },
  },
  multicall: {
    address: '0xcf591ce5574258ac4550d96c545e4f3fd49a74ec',
    blockCreated: 7162653,
  },
  nativeCurrency: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18,
  },
}



const PROJECT_ID = '27b9720018bf7f8740936e6a6eb28604'

if (!PROJECT_ID) {
  throw new Error('Project ID is not defined')
}


// Set up queryClient
const queryClient = new QueryClient()

// Set up metadata
const metadata = {
  name: 'Reown',
  description: 'Reown',
  url: 'https://reown.com', // origin must match your domain & subdomain
  icons: ['https://reown.com/favicon.ico'],
}

// Create the modal
export const modal = createAppKit({
  adapters: [wagmiAdapter],
  projectId: PROJECT_ID,
  networks: [bsc],
  metadata,
  features: {
    analytics: true, // Optional - defaults to your Cloud configuration
    socials: [],
    email: false,
    onramp: false,
    swaps: false,
    send: false
  },
  themeVariables: {
    '--w3m-accent': '#000000',
  }
})

function WalletProvider({ children }) {

  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig} initialState={null}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  )
}

export default WalletProvider